var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgErrorConfirming = function SvgErrorConfirming(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-17490.387 293.696 103.109 103.111",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    d: "M62.473,10.917a51.6,51.6,0,1,0,51.556,51.556A51.557,51.557,0,0,0,62.473,10.917ZM84.957,79.36a3.958,3.958,0,0,1-5.6,5.6L62.473,68.07,45.584,84.956a3.958,3.958,0,0,1-5.6-5.6L56.876,62.473,39.988,45.585a3.957,3.957,0,1,1,5.6-5.6L62.473,56.876,79.362,39.987a3.957,3.957,0,0,1,5.6,5.6L68.068,62.473Z",
    transform: "translate(-17501.305 282.779)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorConfirming, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ErrorConfirming.2a61a60c.svg";
export { ForwardRef as ReactComponent };